import React, { useEffect, useState } from "react";
import { AllPoForm } from "./allpoForm";
import AllPOGrid from "./allpogrid";


const AllPo =()=>{
   

    return(
        <>
        <AllPoForm/>
       <AllPOGrid/>
        </>
    )
}

export default AllPo;